export const scrollToErrors = () => {
  setTimeout(() => {
    try {
      var errors = document.getElementsByClassName("has-error");
      if (errors.length) {
        const firstEl = errors[0];
        scrollTo(findPos(firstEl), 200);
        focusFirstInput(firstEl);
      }
    } catch (e) {}
  }, 100);
};

const focusFirstInput = element => {
  try {
    element.querySelector("input").focus();
  } catch (err) {}
};

function findPos(obj) {
  let top = 0;
  if (obj.offsetParent) {
    do {
      top += obj.offsetTop;
    } while ((obj = obj.offsetParent));
    return [top];
  }
}

export const scrollTo = (elementY, duration) => {
  if (typeof window === "undefined") {
    return;
  }
  var startingY = window.pageYOffset;
  var diff = elementY - startingY;
  var start;

  if (!window.requestAnimationFrame) {
    window.scrollTo(0, elementY);
    return;
  }
  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    // Elapsed miliseconds since start of scrolling.
    const time = timestamp - start;
    // Get percent of completion in range [0, 1].
    const percent = Math.min(time / duration, 1);
    window.scrollTo(0, startingY + diff * percent);
    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
};
